'use client';

import Image from 'next/image';
import { Link } from './type';
interface Props {
  item: Partial<Link>;
}
function CertificateLink({
  item
}: Props) {
  const {
    imageUrl,
    name,
    popup
  } = item;
  return <div className='rounded bg-surface-solid-0 px-0.5 py-1 lg:px-1' data-sentry-component="CertificateLink" data-sentry-source-file="certificate-link.tsx">
            <Image unoptimized src={imageUrl || ''} alt={name || ''} width={50} height={64} className='h-14 w-10 cursor-pointer object-contain lg:h-16 lg:w-[45px]' onClick={() => window.open(popup?.url, 'Popup', popup?.options)} loading='lazy' data-sentry-element="Image" data-sentry-source-file="certificate-link.tsx" />
        </div>;
}
export default CertificateLink;